// extracted by mini-css-extract-plugin
export default {"cont":"ConditionNode_cont__LfOSC","details":"ConditionNode_details__8lqe5","placeholder":"ConditionNode_placeholder__Rup4z"};